import _ from 'lodash';
import moment from 'moment';
import CashflowViewApi from '../../api/CashflowViewApi';

const MONTHS_BACK = 5;

async function getBudget(budgetDate) {
  return CashflowViewApi.fetchBudget({ budgetDate });
}

async function getBudgets(budgetDates) {
  const latestBudgetDate = _.chain(budgetDates).sort().last().value();
  const customerBudgets = await CashflowViewApi.fetchPreviousBudgets({ budgetDate: latestBudgetDate, numMonthsBack: budgetDates.length - 1 });
  return _.chain(customerBudgets)
    .filter(budget => _.includes(budgetDates, budget.budgetDate))
    .sortBy(budget => budget.budgetDate)
    .reverse()
    .value();
}

function getPresentedBudgetDates() {
  const currentBudgetDate = getCurrentBudgetDate();
  return _extendMonthsBack(currentBudgetDate, MONTHS_BACK);
}

function getYearBackBudgetDates() {
  const currentBudgetDate = getCurrentBudgetDate();
  return _extendMonthsBack(currentBudgetDate, 12);
}

function _extendMonthsBack(openMonthBudgetDate, numMonthsBack) {
  const openBudgetDate = moment(openMonthBudgetDate);
  const presentedBudgetDates = [openMonthBudgetDate];
  for (let i = 1; i <= numMonthsBack; i++) {
    presentedBudgetDates.push(openBudgetDate.clone().subtract(i, 'month').format('YYYY-MM'));
  }
  return _.filter(presentedBudgetDates);
}

function getCurrentBudgetDate() {
  return moment().format('YYYY-MM');
}

function getPrevBudgetDate(budgetDate) {
  return moment(budgetDate).subtract(1, 'month').format('YYYY-MM');
}

function getNextBudgetDate(budgetDate) {
  return moment(budgetDate).add(1, 'month').format('YYYY-MM');
}

function getMonthName(budgetDate) {
  return moment(budgetDate).locale('he').format('MMM');
}

function getFullMonthName(budgetDate) {
  return moment(budgetDate).locale('he').format('MMMM');
}

function getCashflowsForGraph(allCashflows, presentedBudgetDate, currentBudgetDate) {
  return _.chain(allCashflows)
    .filter(cashflow => cashflow.budgetDate < currentBudgetDate)
    .sortBy(cashflow => cashflow.budgetDate)
    .reverse()
    .chunk(5)
    .find(cashflowChunk => cashflowChunk.map(budget => budget.budgetDate).includes(presentedBudgetDate))
    .value();
}

export default {
  getPresentedBudgetDates,
  getYearBackBudgetDates,
  getBudget,
  getBudgets,
  getCurrentBudgetDate,
  getPrevBudgetDate,
  getNextBudgetDate,
  getMonthName,
  getFullMonthName,
  getCashflowsForGraph,
};
